
<template>
  <v-app>

    <v-snackbar
      v-model="snackbar.snackbar.value"
      :timeout="snackbar.snackbarTimeout.value"
      :color="snackbar.snackbarColor.value"
      location="top right"
    >
      {{ snackbar.snackbarMessage.value }}
      <template v-slot:actions>
        <v-btn
          variant="text"
          append-icon="mdi-close-circle"
          @click="snackbar.closeSnackbar"
        ></v-btn>
      </template>
    </v-snackbar>


    <v-overlay
      persistent
      :model-value="overlay.overlay.value"
      class="align-center justify-center"
      style="z-index: 999999"
    >
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-main>
      <router-view />
    </v-main>
    <!-- <v-footer app>
     <div> footer</div>
     </v-footer> -->
  </v-app>
</template>

<script>
//import user from './users.json'
import { inject } from 'vue'

export default {
  name: "App",
  components: {
    // HelloWorld
  },
  setup() {
    const snackbar = inject('$snackbar')
    const overlay = inject('$overlay')

    return {
      snackbar,
      overlay,
    };
  },
  data() {
    return {
      //user: user
      //user
    };
  }
};
</script>

<!-- <template>
  <img
    alt="Vue logo"
    src="./assets/logo.png"
  />
  <HelloI18n />
</template>

<script>
import HelloI18n from "./components/HelloI18n.vue";

export default {
  name: "App",
  components: {
    HelloI18n
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style> -->
